export namespace GroupEnums{ 
    export enum GroupIds{
Colour=5
}}

